(function(angular) {
    angular
        .module('repairforms.service.module')
        .service('UrlParserService', UrlParserService);

    UrlParserService.$inject = [];

    function UrlParserService(){
        return {
            parseURL: parseURL
        };

        function parseURL(search){
            var result = {};

            var urlParams = search;
            if(urlParams === undefined || urlParams.length === 0) {
                return;
            }

            var urlParts = urlParams.split('?');
            if(urlParts.length > 1) {
                urlParams = urlParts[1];
                var pairs = urlParams.split('&');
                pairs.forEach(function(element, index) {
                    var nameVal = element.split('=');
                    if(nameVal.length === 2) {
                        convertProblematicSigns(nameVal);
                        result[nameVal[0]] = nameVal[1];
                    }
                });
            }

            return result;
        }

        function convertProblematicSigns(nameVal){
            nameVal[0] = nameVal[0].replace(/\./g, "_");
            nameVal[0] = nameVal[0].replace('%5B','');
            nameVal[0] = nameVal[0].replace('%5D','');
            nameVal[1] = decodeURIComponent(nameVal[1]);
            return nameVal;
        }

    };

})(angular);